// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1pdEL","modalFooterButton":"ModalNotes_modalFooterButton__1wS6w"};